"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var installation_water_level_indicator_component_1 = __importDefault(require("./installation-water-level-indicator.component"));
var waterLevelHeight = function (props) {
    var _a, _b;
    var height = props.height, topOffset = props.topOffset, highestSetting = props.highestSetting, waterLevel = props.waterLevel;
    var activeWaterLevel = (_b = (_a = waterLevel.analog) !== null && _a !== void 0 ? _a : waterLevel.digital) !== null && _b !== void 0 ? _b : 0;
    var waterLevelHeight = ((height - topOffset) / highestSetting) * activeWaterLevel;
    return waterLevel > highestSetting ? height : waterLevelHeight;
};
var InstallationWaterLevelContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top: 1px solid ", ";\n  background-color: ", ";\n  position: absolute;\n  left: ", ";\n  bottom: 0;\n  height: ", ";\n  width: ", ";\n  z-index: 1;\n  transition: height ease-in 0.4s;\n  box-sizing: border-box;\n"], ["\n  border-top: 1px solid ", ";\n  background-color: ", ";\n  position: absolute;\n  left: ", ";\n  bottom: 0;\n  height: ",
    ";\n  width: ", ";\n  z-index: 1;\n  transition: height ease-in 0.4s;\n  box-sizing: border-box;\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.installationSketch.waterSurface;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.installationSketch.water;
}, function (_a) {
    var width = _a.width, sketchValues = _a.sketchValues;
    return Math.floor(width * sketchValues.leftBreakPoint) + "px";
}, function (_a) {
    var height = _a.height, waterLevel = _a.waterLevel, highestSetting = _a.highestSetting, sketchValues = _a.sketchValues;
    return waterLevelHeight({ height: height, waterLevel: waterLevel, highestSetting: highestSetting, topOffset: sketchValues.topOffset }) + "px";
}, function (_a) {
    var width = _a.width, sketchValues = _a.sketchValues;
    return Math.floor(width * sketchValues.middleDistance) + "px";
});
InstallationWaterLevelContainer.displayName = 'InstallationWaterLevelContainer';
var IndicatorContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  bottom: ", ";\n  transform: translate(-120%, -80%);\n  left: ", ";\n  transition: bottom ease-in 0.4s;\n"], ["\n  position: absolute;\n  bottom: ",
    ";\n  transform: translate(-120%, -80%);\n  left: ",
    ";\n  transition: bottom ease-in 0.4s;\n"])), function (_a) {
    var height = _a.height, waterLevel = _a.waterLevel, highestSetting = _a.highestSetting, sketchValues = _a.sketchValues;
    return waterLevelHeight({ height: height, waterLevel: waterLevel, highestSetting: highestSetting, topOffset: sketchValues.topOffset }) + "px";
}, function (_a) {
    var width = _a.width, sketchValues = _a.sketchValues;
    return Math.floor(width * (sketchValues.middleDistance + sketchValues.leftBreakPoint)) + "px";
});
var InstallationWaterLevel = function (props) {
    var _a, _b;
    var activeWaterLevel = (_b = (_a = props.waterLevel.analog) !== null && _a !== void 0 ? _a : props.waterLevel.digital) !== null && _b !== void 0 ? _b : 0;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(InstallationWaterLevelContainer, __assign({}, props, { "data-test-id": 'water-level-area' })),
        props.hideWaterLeveIndicator !== true && (react_1.default.createElement(IndicatorContainer, __assign({}, props),
            react_1.default.createElement(installation_water_level_indicator_component_1.default, { waterLevel: activeWaterLevel, unit: props.unit })))));
};
InstallationWaterLevel.displayName = 'InstallationWaterLevel';
exports.default = InstallationWaterLevel;
var templateObject_1, templateObject_2;
//# sourceMappingURL=installation-water-level.component.js.map